module.exports = __webpack_public_path__ + "img/series_05.32581a45.png";